import type { Brief, QualityChanges } from '@/lib/types'
import { BriefView } from '@/components/BriefForm'
import { wordDiff } from '@/lib/diff'

export function QualityPrompt({ prompt, changes }: { prompt: string; changes?: QualityChanges | null }) {
  const change = changes?.changes.find(item => item.field === 'prompt')
  const current = typeof change?.after === 'string' ? change.after : prompt
  if (typeof change?.before !== 'string') return <pre>{current}</pre>
  return <pre className="diff">{wordDiff(change.before, current).map((part, index) =>
    part.kind === 'add' ? <ins key={index}>{part.text}</ins>
      : part.kind === 'del' ? <del key={index}>{part.text}</del> : <span key={index}>{part.text}</span>)}</pre>
}

export function QualityBrief({ brief, changes }: { brief: Brief; changes?: QualityChanges | null }) {
  const change = changes?.changes.find(item => item.field === 'brief')
  const before = change?.before && typeof change.before === 'object' ? change.before as Brief : undefined
  const current = change?.after && typeof change.after === 'object' ? change.after as Brief : brief
  return <BriefView brief={current} before={before} />
}
